// extracted by mini-css-extract-plugin
export var box = "_7p-1";
export var checkboxRow = "_7p-8";
export var checked = "_7p-2";
export var descriptionSpacer = "_7p-a";
export var disabled = "_7p-3";
export var icon = "_7p-6";
export var input = "_7p-0";
export var labelSpacer = "_7p-9";
export var medium = "_7p-5";
export var small = "_7p-4";
export var text = "_7p-7";